import { useStateMachine } from 'little-state-machine';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';

import { Button, Expand, InputPassword, InputText } from '@/components';
import { updateFormActionLander } from '@/hooks';
import { OutletContext } from '@/model';
import { UsernamePasswordValidation } from '@/validations';

interface UsernamePasswordForm {
	username: string;
	password: string;
}

export const UsernamePassword = () => {
	const { handleNext, versionId }: OutletContext = useOutletContext();
	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm<UsernamePasswordForm>({ resolver: UsernamePasswordValidation });
	const { actions, state } = useStateMachine({ updateFormActionLander });

	const onSubmit = (data: UsernamePasswordForm) => {
		actions.updateFormActionLander({ lander: { ...state.lander, ...data } });
		handleNext();
	};

	return (
		<form onSubmit={handleSubmit(onSubmit)} className="flex flex-col">
			<div className="flex flex-col gap-3.5">
				<InputText
					{...register('username')}
					placeholder="Indtast dit brugernavn"
				/>
				<Expand expanded={Boolean(errors.username)}>
					<p
						className={`pandora__form--error pandora__form--error--v${versionId}`}
					>
						{errors.username?.message}
					</p>
				</Expand>
				<InputPassword
					{...register('password')}
					placeholder="Indtast dit kodeord"
				/>
				<Expand expanded={Boolean(errors.password)}>
					<p
						className={`pandora__form--error pandora__form--error--v${versionId}`}
					>
						{errors.password?.message}
					</p>
				</Expand>
			</div>
			<Button>Næste</Button>
		</form>
	);
};
